import moment from "moment-timezone";

import { RequestParamsPayload, RequestPayload } from "hooks/index.types";
import { RequestConfig } from "utils/types";
import {
  BusinessStatsPayload,
  FeatureProductsPayload,
} from "utils/types/apiPayload";
import { dateTimeFormats } from "utils/constants";
import { LOYALTY_URL } from "config";

// ==============================|| API endPoints ||============================== //

// capture third party payments
export const capturePayments = (): RequestConfig => ({
  url: "/third_party_payment_integration",
  method: "POST",
});

// capture third party payments
export const updateLoyalty = (
  campaignId: number,
  businessId: string
): RequestConfig => ({
  url: `${LOYALTY_URL}/campaign/${campaignId}/business/${businessId}`,
  method: "PUT",
});

// feature products
export const featureItems = (businessId: string): RequestConfig => ({
  url: `${process.env.REACT_APP_SERVERLESS}/${businessId}/products/featured`,
  method: "POST",
});

// business stats
export const getBusinessStats = (businessId: string): RequestConfig => ({
  url: `${process.env.REACT_APP_SERVERLESS}/${businessId}/stats`,
  method: "GET",
});

// create quickBook order
export const createQuickBookOrder = (orderId: string): RequestConfig => ({
  url: `/qbcreateinvoice/${orderId}`,
  method: "GET",
});

// cancel quickBook order
export const cancelQuickBookOrder = (invoiceId: string): RequestConfig => ({
  url: `/qbdeleteinvoice/${invoiceId}`,
  method: "GET",
});

// ==============================|| API payloads ||============================== //

// feature items API payload
export const featureItemsAPIPayload = (
  itemId: string,
  status: boolean
): RequestPayload<FeatureProductsPayload> => {
  return {
    data: { items: [{ id: Number(itemId), featured: (status && 1) || 0 }] },
  };
};

// get business stats API payload
export const getBusinessStatsAPIPayload = ({
  startDate,
  endDate,
  categories = true,
  products = true,
  areas = true,
  branchWiseSummary = true,
}: BusinessStatsPayload): RequestParamsPayload<BusinessStatsPayload> => {
  const dateFormat: string = `${dateTimeFormats?.DATE} ${dateTimeFormats?.TIME}`;

  return {
    params: {
      startDate: moment(startDate).startOf("day").format(dateFormat),
      endDate: moment(endDate).endOf("day").format(dateFormat),
      categories,
      products,
      areas,
      branchWiseSummary,
    },
  };
};

// input JSON and return formData for API payload
export const generateFormData = (
  data: Record<string, string | Blob | number | boolean>
): FormData => {
  const formData = new FormData();

  // append values in formData
  Object.entries(data)?.forEach(([key, value]) => {
    formData.append(key, value?.toString());
  });

  return formData;
};
